export enum metricType {
    PERCENTAGE = 'percentage',
    CURRENCY = 'currency',
    DECIMAL = 'decimal',
    NUMERIC = 'numeric',
}

export enum Numbers {
    ZERO = 0,
    ONE = 1,
    TWO = 2,
    THREE = 3,
    FOUR = 4,
    FIVE = 5,
    SIX = 6,
    SEVEN = 7,
    EIGHT = 8,
    NINE = 9,
    TEN = 10,
    ELEVEN = 11,
    TWELVE = 12,
    THIRTEEN = 13,
    FOURTEEN = 14,
    FIFTEEN = 15,
    SIXTEEN = 16,
    SEVENTEEN = 17,
    EIGHTEEN = 18,
    NINETEEN = 19,
    TWENTY = 20,
    TWENTYONE = 21,
    TWENTYTWO = 22,
    TWENTYTHREE = 23,
    TWENTYFOUR = 24,
    THIRTY = 30,
    THIRTYONE = 31,
    FORTY = 40,
    FIFTY = 50,
    SIXTY = 60,
    SEVENTY = 70,
    EIGHTY = 80,
    NINETY = 90,
    HUNDRED = 100,
}

export enum MetricColor {
    METRIC_1 = '#ab0aa8',
    METRIC_2 = '#f7d040',
    METRIC_3 = '#f728f4',
    METRIC_4 = '#0ff7d8',
    METRIC_5 = '#13ab97',
    METRIC_6 = '#ab0aa8',
    METRIC_7 = '#f7d040',
    METRIC_8 = '#50CD89',
    METRIC_9 = '#ffffff',
}

export enum AgentMetricMetColor {
    METRIC_MET1 = '#f74040',
    METRIC_MET2 = '#ddf740',
    METRIC_MET3 = '#f7d040',
    METRIC_MET4 = '#0ff7d8',
    METRIC_MET5 = '#50cd89',
    METRIC_MET6 = '#ab0aa8',
    METRIC_MET7 = '#f7d040',
}

export enum ConstReviewStatus {
    NEEDS_REVIEW = 1,
    REVIEWED = 2,
    DISPUTED = 3,
}

export enum ConstApprovalStatus {
    OPEN = 1,
    DISPUTED = 2,
    ASSOCIATE_APPROVED = 3,
    TEAM_LEAD_APPROVED = 4,
    MANAGER_APPROVED = 5,
    READY_FOR_EXTRACT = 6,
    CLOSED = 7,
    DISQUALIFIED = 8,
}

export enum ConstPayoutApprovalStatus {
    UNAPPROVED = 1,
    APPROVED = 2,
    DISQUALIFIED = 3,
}
export enum ConstApplicationRole {
    ASSOCIATE = 1,
    TEAM_LEAD = 2,
    MANAGER = 3,
}
export enum ConstScorecardRole {
    ASSOCIATE = 1,
    TEAM_LEAD = 2,
}
export enum ConstReasonType {
    SCORECARD_DISPUTE_REASON = 3,
    SCORECARD_RESOLUTION_REASON = 4,
    SCORECARD_APPROVAL_HALT_REASON = 5,
}
export enum ConstApprovalWindowStatus {
    APPROVALS_NOT_STARTED = 1,
    ASSOCIATE_WINDOW = 2,
    TEAM_LEAD_WINDOW = 3,
    MANAGER_WINDOW = 4,
    COMPENSATION_TEAM_WINDOW = 5,
    READY_FOR_EXTRACT = 6,
    CLOSED = 7,
    APPROVALS_HALTED = 8,
}

export const monthNames: { [key: number]: string } = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
};

export enum Tabindex {
    Search = 0,
    Configuration = 1,
    Create = 2,
    Edit = 3,
    Dashboard = 5,
    View = 4,
    AssignSearch = 6,
}
export enum CaMenuTabindex {
    AssignmentUpdates = 0,
    NeedsAction = 1,
    MyCorrectiveActions = 2,
    Records = 3,
}

export enum CaStatus {
    Draft = 1,
    ApprovalPending = 2,
    Approved = 3,
    Rejected = 4,
    Recalled = 5,
    Release = 6,
    Acknowledged = 7,
}

export enum CaApprovalAction {
    Submit = 1,
    Approve = 2,
    Release = 3,
    Acknowledged = 4,
    Reject = 5,
    Recall = 6,
    Resubmit = 7,
    Save_As_Draft = 8,
}

export enum CaUserTypes {
    approver = 'approver',
    author = 'author',
    TLOrManager = 'TLOrManager',
}

export enum CaStatusNames {
    Draft = 'Draft',
    ApprovalPending = 'Approval Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Recalled = 'Recalled',
    Release = 'Released',
    Acknowledged = 'Acknowledged',
    AutoClosed = 'Auto-Closed',
}

export enum MoodType {
    Happy = 'happy',
    Question = 'question',
    Tired = 'tired',
    DontFeelWell = 'dontfeelwell',
    Confused = 'confused',
    Upset = 'upset',
}

export enum QuestionNumber {
    questionNumber = '8989898',
}

export enum SadStaticAnswer {
    staticAnswer = 'I have concerns or need help',
}

export enum Answer {
    itsGoingWell = "It's going well so far",
    needHelp = 'I have concerns or need help',
}

export enum Question {
    questionEmpower = 'Empower : Everyday Mood meter',
    questionEmpowerFeedback = 'Empower : Everyday Mood meter Feedback',
}

export enum AssignmentTabIndex {
    Dashboard = 0,
    View = 2,
    Assignment = 1,
    Updates = 3,
    Acknowledged = 4,
}

export enum MyDashboardCA {
    Dashboard = 0,
    Acknowledged = 1,
}
export enum HCRecordsCA {
    Records = 0,
    RecordView = 1,
}
export enum CoachingTabs {
    Coaching = 0,
    Conversation = 1,
    MyTODos = 2,
    History = 3,
    CoachingInsights = 4,
    CoachingObservations = 5,
    CorrectiveActions = 6,
    GamePlan = 7,
    RecordingHistory = 8,
    shoutOut = 9,
    CAP = 10,
    CoachingActionPlan = 20,
    CoachingHistory = 21,
}
export enum CoachingEntityTypes {
    General = 1,
    Conversations = 2,
    Strengths = 3,
    Metrics = 4,
    Goals = 5,
    CoachingObservations = 6,
    CoachingInsights = 7,
    CorrectiveActions = 8,
    Gameplan = 10,
    Recordings = 11,
    RecordingCAP = 12,
    CoachingActionPlan = 14,
    CoachingMetricRecognition = 15
}
export enum CoachingNextBestActionType {
    StartCoaching = 1,
    Recognize = 2,
    FollowUp = 3,
    Review = 4,
    NoData = 5,
}
export interface Notification {
    notification_id: number;
    notification_subject: string;
    notification_text: string;
    sender_employee_number: string;
    sender_name: string;
    notification_read: boolean;
    notification_read_date: string;
    create_date: string;
    unread_count: number;
}

//#Scorecard approval initial status steps
export const StepperSteps = [
    {
        stepId: 1,
        stepName: 'Approvals',
        isProgress: false,
        isStalled: false,
        isHalted: false,
        colorCode: '#CECECD',
        icon: '',
        subHeading: '',
        pct: 0,
    },
    {
        stepId: 2,
        stepName: 'Associate Window',
        inProcess: false,
        isStalled: false,
        isHalted: false,
        colorCode: '#CECECD',
        subHeading: '',
        icon: '',
        pct: 0,
    },
    {
        stepId: 3,
        stepName: 'TL Window',
        inProcess: false,
        isStalled: false,
        isHalted: false,
        colorCode: '#CECECD',
        subHeading: '',
        icon: '',
        pct: 0,
    },
    {
        stepId: 4,
        stepName: 'Manager Window',
        inProcess: false,
        isStalled: false,
        isHalted: false,
        colorCode: '#CECECD',
        subHeading: '',
        icon: '',
        pct: 0,
    },
    {
        stepId: 5,
        stepName: 'Compensation',
        inProcess: false,
        isStalled: false,
        isHalted: false,
        colorCode: '#CECECD',
        subHeading: '',
        icon: '',
        pct: 0,
    },
    {
        stepId: 6,
        stepName: 'Ready For Extract',
        inProcess: false,
        isStalled: false,
        isHalted: false,
        colorCode: '#CECECD',
        subHeading: '',
        icon: '',
        pct: 0,
    },
    {
        stepId: 7,
        stepName: 'Closed',
        inProcess: false,
        isStalled: false,
        isHalted: false,
        colorCode: '#CECECD',
        icon: '',
        subHeading: '',
        pct: 0,
    },
];
